export const NAME_ROUTES = {
    HOME: { path: '/', name: 'home' },
    LOGIN: { path: '/login', name: 'login' },
    DELETE_ACCOUNT: { path: '/delete-account', name: 'deleteAccount' },
    // Acceso por token (`RouteAccess.UrlToken`), igual que en el frontend original del tenant con token.
    ITEM_DETAIL: { path: '/item/:id/:token', name: 'itemDetail' },
    // Siniestros de un item (acceso por token). Mismo path y nombre que en el frontend original.
    ITEM_CLAIMS: { path: '/item/claims/:id/:token', name: 'itemWithSinisters' },
    // Lista de siniestros (sesión). Antes compartía el nombre `itemWithSinisters` con ITEM_CLAIMS.
    CLAIMS_LIST: { path: '/claims/', name: 'claimsList' },
    CLAIM_DETAIL: { path: '/claim/detail/:id', name: 'claimDetail' }
};
